(function () {
  var THRESHOLD = 40;
  var header = document.getElementById('header-component');
  if (!header) return;

  var ticking = false;

  function update() {
    var scrolled = window.scrollY > THRESHOLD;
    document.documentElement.classList.toggle('sp-scrolled', scrolled);
    header.classList.toggle('header--compact', scrolled);
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();
